import { Link } from 'react-router-dom';
import { Lock, Home } from 'lucide-react';
import { PageContainer } from '@/components/design-system';
import { Button } from '@/components/ui/button';

// Sprint 8.2 — Affiché lorsqu'un user authentifié n'a pas la permission requise
// pour accéder à une page. La sidebar masque déjà ces pages, mais l'accès direct
// par URL doit être bloqué côté composant.

interface Props {
  /** Feature key requise (informatif, affichée dans le détail). */
  feature?: string;
  /** Message contextuel optionnel. */
  message?: string;
}

export function AccessDenied({ feature, message }: Props): JSX.Element {
  return (
    <PageContainer>
      <div className="mx-auto mt-12 max-w-md rounded-xl border border-amber-200 bg-amber-50/60 p-6 text-center">
        <Lock className="mx-auto h-10 w-10 text-amber-600" />
        <h1 className="mt-3 text-lg font-bold text-slate-900">Accès refusé</h1>
        <p className="mt-2 text-sm text-slate-700">
          {message ??
            "Vous n'avez pas la permission requise pour accéder à cette page. Contactez votre administrateur si besoin."}
        </p>
        {feature && (
          <p className="mt-1 font-mono text-[10px] text-slate-500">
            Permission requise : {feature}
          </p>
        )}
        <Button asChild className="mt-4">
          <Link to="/">
            <Home className="h-3.5 w-3.5" /> Retour au tableau de bord
          </Link>
        </Button>
      </div>
    </PageContainer>
  );
}
